<template>
  <ul class="sc-object-card__list-cameras" v-if="data && data.length">
    <li
      class="sc-object-card__list-cameras-item"
      v-for="(item, i) in data"
      :key="`qwe123${i}`"
    >
      <hard-item-camera :info="item" />
    </li>
  </ul>
  <div class="sc-object-card__list-cameras-no-data" v-else-if="isLoading">
    <r-text>{{ $t("loading") }}</r-text>
  </div>
  <div class="sc-object-card__list-cameras-no-data" v-else>
    <r-text>{{ $t("no-cameras") }}</r-text>
  </div>
</template>

<script>
import hardItemCamera from "./renderer/list-item-hard-camera";

export default {
  components: { hardItemCamera },
  data() {
    return {
      isLoading: false,
      response: null,
      refreshData: null
    };
  },
  computed: {
    data() {
      return this.response;
    }
  },
  methods: {
    async getData() {
      try {
        const response = await fetch(
          "https://lenobl.ritm3.ru/xml_server_results/?limit=10"
        );
        const responseJson = await response.json();

        this.response = responseJson;
        this.isLoading = false;
      } catch (e) {
        console.log(e);
        this.isLoading = false;
      }
    }
  },
  created() {
    this.isLoading = true;
    this.getData();
    this.refreshData = setInterval(this.getData, 2000);
  },
  beforeDestroy() {
    clearInterval(this.refreshData);
  }
};
</script>

<style lang="scss" scoped>
.sc-object-card__list-cameras {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  &-item {
    width: 100%;
    height: auto;
    margin-bottom: 16px;
    position: relative;
    border-radius: var(--border-radius);
    overflow: hidden;
    &:last-child {
      margin-bottom: 0;
    }
  }
  &-no-data {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    max-height: 40px;
  }
}
</style>

<i18n>
{
  "ru": {
    "no-cameras": "Камер нет",
    "loading": "Загрузка данных"
  },
  "en": {
    "no-cameras": "No cameras",
    "loading": "Data loading"
  }
}
</i18n>
